import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  wp: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
}

const WhitePapersItem = ({ wp }) => {
  const { childMarkdownRemark } = wp
  const { frontmatter } = childMarkdownRemark

  const item = {
    id: childMarkdownRemark.id,
    slug: frontmatter.slug,
    title: frontmatter.title,
    featuredImage: frontmatter.featuredImage,
    author: frontmatter.author,
    createdAt: frontmatter.createdAt

  }

  // return <pre>{JSON.stringify(item, null, 2)}</pre>
  return (
      <div className="inner">
        <a href={item.slug}>
          <div className={`resource__image white_paper`}>
            {item.featuredImage && (
                <img
                    src={item.featuredImage}
                    alt={item.title}
                />
            )}
            <div className="resource__category">WHITEPAPER</div>
          </div>

          <div className="resource__body white_paper_resource_body">
            <div className="resource__quoter">{item.title}</div>
            <div className="articlePublished">
              {item.createdAt}
              {item.author && <span>&nbsp;by {item.author}</span>}
            </div>
          </div>
        </a>
      </div>
  )
}

WhitePapersItem.propTypes = propTypes

export default WhitePapersItem
